import { useCurrentUser } from '@/hooks/useCurrentUser'
import type { ApiPlanDetailResponse } from '@/types'

/**
 * Whether the current user may freeze/unfreeze a plan.
 * Allowed for admins, the plan owner, and collaborators the owner granted
 * freeze permission to. The backend computes this as `can_freeze`; the
 * owner/admin check is only a fallback for responses without the field.
 */
export function useCanFreezePlan(
  plan?: Pick<ApiPlanDetailResponse, 'can_freeze' | 'owner'> | null
): boolean {
  const { userId, isAdmin } = useCurrentUser()
  if (plan?.can_freeze != null) return plan.can_freeze
  return isAdmin || (plan?.owner?.id != null && plan.owner.id === userId)
}
